import React, {useEffect, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {NewsCard} from "../NewsCard";
import {Pagination} from "../Pagination";

const getDisplayItem = (pageNumber, itemsPerPage, allNews) => {
    const start = (pageNumber-1)*itemsPerPage
    const end = pageNumber*itemsPerPage
    return allNews.slice(start,end)
}

const getProject = (projects, id) => {
    return projects.find(item => item.id === id)
}

const NewsList = ({allNews, projects, projectId}) => {
    const itemsPerPage = 10
    const location = useLocation()
    const [pageNumber, setPageNumber] = useState(1)
    const [displayItems, setDisplayItems] = useState(allNews)

    useEffect( () => {
        const page = new URLSearchParams(location.search).get("page")
        if ( page !== null ) {
            setPageNumber(parseInt(page))
        } else {
            setPageNumber(1)
        }
    }, [location])

    useEffect( () => {
        setDisplayItems(getDisplayItem(pageNumber, itemsPerPage, allNews));
    }, [pageNumber, itemsPerPage, allNews])


    const firstCard = displayItems.slice(0,1).map((item, index) => {
        let background = 'primary-background'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={2} extraClasses={background}/>
    })

    const secondCard = displayItems.slice(1,2).map((item, index) => {
        let background = 'secondary-background'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={1} extraClasses={background}/>
    })

    const thirdCard = displayItems.slice(2,3).map((item, index) => {
        let background = 'primary-background-alt'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={4} extraClasses={background}/>
    })

    const fourthCard = displayItems.slice(3,4).map((item, index) => {
        let background = 'secondary-background-alt'
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={2} extraClasses={background}/>
    })

    const remainingCards = displayItems.slice(4).map((item, index) => {
        let background = 'primary-background'
        if ( index % 2 === 1 ) {
            background = 'secondary-background'
        }
        return <NewsCard key={item.link} item={item} project={getProject(projects, item.projectId)} cardSize={1} extraClasses={background}/>
    })

    return (
        <>
            <div className="row gx-3 gy-3">
                <div className="col">
                    <Pagination itemsPerPage={itemsPerPage} pageNumber={pageNumber} numItems={allNews.length} linkBase={`/news?project=${projectId}&page=`}/>
                </div>
            </div>
            <div className="row gx-3 gy-3 mb-3">
                {firstCard}
                {secondCard}
                {thirdCard}
                {fourthCard}
                {remainingCards}
            </div>
            <div className="row gx-3 gy-3">
                <div className="col">
                    <Pagination itemsPerPage={itemsPerPage} pageNumber={pageNumber} numItems={allNews.length} linkBase={`/news?project=${projectId}&page=`}/>
                </div>
            </div>
        </>
    )
}

export default NewsList
